import pageSelect from "./src/page-select.vue";
pageSelect.install = function (Vue) {
  Vue.component(pageSelect.name, pageSelect);
};
export default pageSelect;
